import { useContext } from 'react';
import { DebtTrackingStore } from '../stores/debtTrackingStore';
import { StoreContext } from '@roc/feature-app-core';

export const useDebtTrackingStore = () =>
  useContext<{
    debtTrackingStore: DebtTrackingStore;
  }>(StoreContext);
